import axios from 'axios'
import { ambienteValido } from './regras'

export async function carregarEnvParceiro (ambiente, envBuild) {
  if (!ambiente || ambiente === envBuild.VUE_APP_AMBIENTE || !ambienteValido(ambiente)) {
    return envBuild
  }
  const { data } = await axios.get('/parceiros/' + ambiente + '.json')
  return { ...envBuild, VUE_APP_AMBIENTE: ambiente, ...data }
}
